'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = freezeProps;

var _ramda = require('ramda');

var _is_model = require('./is_model');

var _immutable = require('../../immutable');

var isSomethingNaturallyImmutable = (0, _ramda.either)(_is_model.isModel, _immutable.isImmutableType);
var isObjectOrArray = (0, _ramda.either)((0, _ramda.is)(Object), (0, _ramda.is)(Array));
var shouldFreeze = (0, _ramda.both)((0, _ramda.complement)(isSomethingNaturallyImmutable), isObjectOrArray);

function deepFreeze(obj) {
  (0, _ramda.forEach)((0, _ramda.when)(shouldFreeze, deepFreeze), (0, _ramda.values)(obj));

  return Object.freeze(obj);
}

function freezeProps(props) {
  return deepFreeze(props);
}